import { styled } from '@acko-tech/building-blocks.ui.common';

export const SingleCashlessCardWrapper = styled.div`
    margin-top: 20px;
    padding: 20px;
    background: #f6f7fb;
    border-radius: 6px;
`;

export const LogoWrapper = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
`;

export const AckoLogo = styled.div`
    display: flex;
    justify-content: flex-start;
`;

export const LinkedAssetWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const PolicyOwnerText = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.5px;
    text-align: left;
    margin-top: 20px;
    color: #343758;
`;

export const PolicyDetailsWrapper = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    justify-items: flex-start;
`;

export const PolicyNumberWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 16px;
`;

export const PolicyNumberTitle = styled.div`
    font-weight: 500;
    font-size: 9px;
    line-height: 11px;
    letter-spacing: 0.05em;
    color: #343758;
    text-align: left;
`;

export const PolicyNumberText = styled.div`
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.07em;
    color: #343758;
    text-align: left;
    margin-top: 6px;
`;
